import React from "react";

function Footer() {
  return (
    <footer>
      <p>
        Site and API made by Stephanie Thornley as coursework for Northcoders
        bootcamp, 2020
      </p>
      <a
        href="https://github.com/thorners55/stephanies-nc-news"
        target="_blank"
        rel="noopener noreferrer"
      >
        Front-end GitHub repository
      </a>
      <br />
      <a
        href="https://github.com/thorners55/nc-news"
        target="blank"
        rel="noopener noreferrer"
      >
        Back-end GitHub repository
      </a>
    </footer>
  );
}

export default Footer;
